import { useTypesStore } from '../store/Types';
import { useTypesRender } from '../utils/useRender';
export var Set = props => {
  var {
    Set: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Set');
  return null;
};
Set.displayName = 'JVR.Set';